/** Keys every page renders: the navbar, the footer and the closing call to action. */
export const SHELL_KEYS = [
    'commons',
    'i18nCommons.footer',
    'home.hero_cta',
    'products.family.credentials.title',
    'products.skillsGraphs.name',
    'products.skillsIntelligence.name',
];

/** Sections made of key paths instead of a whole top-level key: the shell, and the FAQ list most pages
 * close with, which lives under `home` but is most of its weight. */
export const BUNDLES = { shell: SHELL_KEYS, faqs: ['home.faqs'] };

/** Translation sections each page renders, by its `slugs` key. The prerender renders every page with
 * exactly these and fails on any key outside them, so a missing one never reaches a browser. */
export const PAGE_SECTIONS = {
    home: ['home', 'prices', 'blog', 'products'],
    companies: ['companies', 'faqs'],
    podcast: ['podcast'],
    prices: ['prices', 'landing', 'mc', 'faqs'],
    features: ['features', 'mc', 'products', 'faqs'],
    team: ['team', 'gg'],
    faqs: ['home'],
    compareCredly: ['compare', 'faqs'],
    compareAccredible: ['compare', 'faqs'],
    compareBadgr: ['compare', 'faqs'],
    compareAcreditta: ['compare', 'faqs'],
    compareCertifier: ['compare', 'faqs'],
    compareHub: ['compareHub', 'compare', 'dc'],
    gg: ['gg', 'dc'],
    dc: ['dc', 'mc', 'faqs'],
    mc: ['mc', 'dc', 'faqs'],
    ob: ['ob', 'dc', 'compare', 'faqs'],
    iee: ['dc', 'landing', 'faqs'],
    employability: ['features', 'dc', 'prices', 'faqs'],
    whiteLabel: ['features', 'dc', 'prices', 'faqs'],
    integrations: ['features', 'dc', 'prices', 'faqs'],
    learningPaths: ['features', 'dc', 'prices', 'faqs'],
    marketing: ['features', 'dc', 'prices', 'faqs'],
    signature: ['features', 'dc', 'prices', 'faqs'],
    massive: ['features', 'dc', 'prices', 'faqs'],
    designer: ['features', 'dc', 'prices', 'faqs'],
    verification: ['features', 'dc', 'prices', 'faqs'],
    campaigns: ['features', 'dc', 'prices', 'faqs'],
    lookup: ['features', 'dc', 'prices', 'faqs'],
    skillsGraphs: ['products', 'prices', 'dc', 'faqs'],
    skillsIntelligence: ['products', 'prices', 'dc', 'faqs'],
    corporateLeads: ['landing'],
};

/** The same, for the pages outside `slugs`, by path. */
export const UNLOCALIZED_PAGE_SECTIONS = {
    contact: PAGE_SECTIONS.prices,
    prices: PAGE_SECTIONS.prices,
};

/** Any other path matches no route and renders the not-found page. */
export const NOT_FOUND_SECTIONS = ['not-found'];

export const BLOG_SECTIONS = ['blog'];
